import Court from './icons/Court.js';
import FullFieldIcon from './icons/FullFieldIcon.js';
import FullLogo from './icons/FullLogo.js';
import HalfFieldIcon from './icons/HalfFieldIcon.js';
import Logo from './icons/Logo.js';
import PlayConfig from './play-config.js';
import Plugins from './plugins.js';
import ToolboxConfig from './toolbox.js';

export default {
    PlayConfig,
    ToolboxConfig,
    Plugins,
    Icons: {
        Court,
        FullLogo,
        Logo,
        FullFieldIcon,
        HalfFieldIcon,
    },
};
